import { MenuItemType } from '@utils/types'
import { A11y, Autoplay, Navigation, Pagination } from 'swiper/modules'
import { SwiperSlide } from 'swiper/react'
import { BreadcrumbType } from '../../../gql/graphql'
import { Breadcrumbs, WContainer } from '../../atoms'
import { HeroHomeSlide } from '../../molecules'
import GenericSlider from '../GenericSlider/GenericSlider'
import styles from './HeroHome.module.sass'

interface Props {
  item: MenuItemType
  className?: string
  breadcrumbs?: BreadcrumbType[]
  type?: 'default' | 'rounded'
  theme?: 'light' | 'neutral10' | 'dark'
  editMode?: boolean
  viewBreadcrumbs?: boolean
}

const HeroHome = (props: Props) => {
  const {
    item = undefined,
    className = '',
    breadcrumbs = undefined,
    type = 'default',
    theme = 'neutral10',
    editMode = false,
    viewBreadcrumbs = false
  } = props

  return item ? (
    <div
      className={`${styles.root} ${className} ${editMode ? styles['root--editMode'] : ''} ${
        styles[`root--${type}`]
      } ${styles[`root--${theme}`]}`}
    >
      <WContainer className={styles.breadcrumbsContainer}>
        {viewBreadcrumbs && breadcrumbs && breadcrumbs.length > 0 && (
          <Breadcrumbs className={styles.breadcrumbs} breadcrumbs={breadcrumbs} variant="dark" />
        )}
      </WContainer>
      {editMode ? (
        <>{item.children}</>
      ) : (
        !!item.children?.length && (
          <div className={`${styles.slider}`}>
            <GenericSlider
              notch
              navigationPos="bottom"
              theme={theme}
              conf={{
                slidesPerView: 1,
                spaceBetween: 10,
                modules: [A11y, Navigation, Pagination, Autoplay],
                navigation: true,
                autoplay: {
                  delay: 5000,
                  disableOnInteraction: false,
                },
                pagination: { clickable: true },
              }}
            >
              {item.children.map((x, index) => (
                <SwiperSlide key={x.pk}>
                  <HeroHomeSlide item={x} variant={type} index={index} />
                </SwiperSlide>
              ))}
            </GenericSlider>
          </div>
        )
      )}
    </div>
  ) : (
    <></>
  )
}

export default HeroHome
